import React from "react";
import { Box, Typography } from "@mui/material";
import { getImage } from "@dishopsaas/design-system";
import { SocialButtonContentProps } from "../../1_types/signinTypes";
import styles from "./ConnexionForm.styles";

const SocialButtonContent: React.FC<SocialButtonContentProps> = ({
  image,
  label,
}) => (
  <Box sx={styles.socialButtonSx}>
    {getImage(
      image,
      {
        size: 24,
        sx: {
          display: "block",
          margin: 0,
          padding: 0,
          marginBottom: 0,
        },
      },
      "none"
    )}
    <Typography variant="button" sx={styles.socialButtonLabel}>
      {label}
    </Typography>
  </Box>
);

export default SocialButtonContent;
